/*
 * sidebar-options
 */
import type { AuthUser } from "@psychology/types"
import type { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { SidebarOptionsItem } from "./sidebar-options-item"
import { SidebarOptionsItemMenu } from "./sidebar-options-item-menu"

interface SidebarOptionsProps {
	getSidebarMenuList: (
		user?: AuthUser | null,
		devMode?: boolean,
		t?: (key: string) => string,
	) => any[]
	bottomContent?: ReactNode
	user?: AuthUser | null
	devMode?: boolean
	children?: ReactNode
	className?: string
}

export function SidebarOptions({
	getSidebarMenuList,
	user,
	devMode,
}: SidebarOptionsProps) {
	const { t } = useTranslation()
	const menuList = getSidebarMenuList(user, devMode, t)

	return menuList.map((content: any, index: number) => (
		<SidebarOptionsItem groupLabel={content.groupLabel} key={index}>
			{content.menus.map(
				({ to, label, icon: Icon, submenus, Badge }: any, index: number) => (
					<SidebarOptionsItemMenu
						to={to}
						label={label}
						submenus={submenus}
						Icon={<Icon className={"size-4"} />}
						Badge={Badge ? <Badge /> : undefined}
						key={index}
					/>
				),
			)}
		</SidebarOptionsItem>
	))
}
